(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.header = null;
      this.headerBounds = { top: 0, bottom: 0 };
      this.headerIsAlwaysSticky = false;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = null;
      this.disclosures = null;
      this.searchModal = null;
      this.isScrolling = null;
      this.headerObserver = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onViewportChangeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.preventHide = this.hasAttribute('data-prevent-hide');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      this.setHeaderHeight();

      this.viewportMediaQuery = window.matchMedia('(max-width: 990px)');

      if (typeof this.viewportMediaQuery.addEventListener === 'function') {
        this.viewportMediaQuery.addEventListener('change', this.onViewportChangeHandler);
      } else if (typeof this.viewportMediaQuery.addListener === 'function') {
        this.viewportMediaQuery.addListener(this.onViewportChangeHandler);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.viewportMediaQuery) {
        if (typeof this.viewportMediaQuery.removeEventListener === 'function') {
          this.viewportMediaQuery.removeEventListener('change', this.onViewportChangeHandler);
        } else if (typeof this.viewportMediaQuery.removeListener === 'function') {
          this.viewportMediaQuery.removeListener(this.onViewportChangeHandler);
        }
      }

      if (this.headerObserver) {
        this.headerObserver.disconnect();
        this.headerObserver = null;
      }

      if (this.isScrolling) {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = null;
      }
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createObserver() {
      if (!this.header || typeof IntersectionObserver === 'undefined') {
        this.updateHeaderBounds();
        return;
      }

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        const entry = entries && entries[0];

        if (entry) {
          this.headerBounds = entry.intersectionRect;
        } else {
          this.updateHeaderBounds();
        }

        observer.disconnect();
        this.headerObserver = null;
      });

      this.headerObserver.observe(this.header);
    }

    updateHeaderBounds() {
      if (!this.header) return;

      const rect = this.header.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop
      };
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const headerBottom = Number.isFinite(this.headerBounds.bottom)
        ? this.headerBounds.bottom
        : 0;
      const headerTop = Number.isFinite(this.headerBounds.top)
        ? this.headerBounds.top
        : 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventHide) {
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          if (this.isScrolling) {
            window.clearTimeout(this.isScrolling);
          }

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
            this.isScrolling = null;
          }, 66);

          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = Math.max(scrollTop, 0);
    }

    hide() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      if (!this.header) return;

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (disclosure && typeof disclosure.close === 'function') {
          disclosure.close();
          return;
        }

        const details = disclosure && disclosure.querySelector('details');
        if (details) details.removeAttribute('open');
      });
    }

    closeSearchModal() {
      if (!this.header) return;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (!this.searchModal) return;

      if (typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
        return;
      }

      const details = this.searchModal.querySelector('details');
      if (details) details.removeAttribute('open');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('order-tracking-uplift')) return;
    class SisfreteTrackingNewTab extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.form = this.querySelector('[data-form]');
        if (!this.form) return;
        this.input = this.querySelector('[data-value]');
        this.message = this.querySelector('[data-message]');
        this.result = this.querySelector('[data-result]');
        this.button = this.querySelector('[data-submit]');
        this.buttonText = this.querySelector('[data-button-text]');
        this.defaultButtonText = this.buttonText.textContent;
        this.defaultPlaceholder = this.defaultPlaceholder ?? this.input.placeholder;
        this.label = this.querySelector('[data-value-label]');
        this.help = this.querySelector('[data-help]');
        this.methods = this.querySelector('[data-methods]');
        this.method = 'tracking_code';
        this.form.querySelector('[data-method][value="tracking_code"]').checked = true;
        this.events = new AbortController();
        this.version = 0;
        this.allowedHosts = new Set((this.dataset.allowedHosts || '').split(',').map(v => v.trim().toLowerCase()).filter(Boolean));
        const options = { signal: this.events.signal };
        this.form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); this.lookup(); }, options);
        this.input.addEventListener('input', () => { this.cancel(); this.clear(); }, options);
        this.form.addEventListener('change', event => {
          if (!event.target.matches('[data-method]')) return;
          const method = event.target.value;
          if (method === 'invoice_number' && this.dataset.invoiceEnabled !== 'true') return;
          if (!['tracking_code', 'invoice_number'].includes(method)) return;
          this.cancel(); this.clear(); this.method = method; this.input.value = '';
          this.updateMethod(); this.input.focus();
        }, options);
        this.methods.hidden = this.dataset.invoiceEnabled !== 'true';
        this.updateMethod();
        this.clear();
        this.form.hidden = false;
      }
      disconnectedCallback() {
        this.cancel();
        this.events?.abort();
        this.events = null;
      }
      updateMethod() {
        const invoice = this.method === 'invoice_number';
        this.label.textContent = invoice ? 'Número da nota fiscal' : 'Código de rastreio';
        this.input.placeholder = invoice ? 'Ex.: 9756' : this.defaultPlaceholder;
        this.input.maxLength = invoice ? 9 : 200;
        this.input.inputMode = invoice ? 'numeric' : 'text';
        this.help.textContent = invoice ? 'Digite o número da nota fiscal, sem a série ou a chave de acesso.' : 'Digite o código ou cole o link de rastreio recebido.';
      }
      busy(value) {
        this.isBusy = value;
        this.button.disabled = value;
        this.form.setAttribute('aria-busy', String(value));
        this.querySelector('[data-spinner]').hidden = !value;
        this.querySelector('[data-button-icon]').hidden = value;
        this.buttonText.textContent = value ? 'Consultando…' : this.defaultButtonText;
      }
      cancel() {
        this.closeTrackingTab();
        this.version = (this.version || 0) + 1;
        this.request?.abort();
        this.request = null;
        if (this.button) this.busy(false);
      }
      clear() {
        this.closeTrackingTab();
        this.message.hidden = true;
        this.message.textContent = '';
        this.result.hidden = true;
        this.result.replaceChildren();
        this.input.removeAttribute('aria-invalid');
      }
      closeTrackingTab() {
        try { if (this.trackingTab && this.trackingTab !== window && !this.trackingTab.closed) this.trackingTab.close(); }
        catch { /* A guia pode ter sido fechada pelo visitante. */ }
        this.trackingTab = null;
      }
      openTrackingTab() {
        if (window.Shopify?.designMode) return;
        try {
          // Abre durante o submit, antes do fetch, para preservar o gesto do visitante.
          const tab = window.open('about:blank', '_blank');
          if (!tab || tab === window) return;
          this.trackingTab = tab;
          this.trackingTab.opener = null;
          this.trackingTab.document.title = 'Consultando rastreio';
          const message = this.trackingTab.document.createElement('p');
          message.textContent = 'Buscando seu rastreio…';
          this.trackingTab.document.body.replaceChildren(message);
        } catch { this.closeTrackingTab(); }
      }
      showMessage(text, state = 'error', field = null) {
        this.message.textContent = text;
        this.message.dataset.state = state;
        this.message.hidden = false;
        if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
      }
      showKnownError(code) {
        if (code === 'INVOICE_NOT_INDEXED') {
          this.showMessage('Ainda não conseguimos localizar esta nota fiscal. Confira o número ou entre em contato com a loja.', 'info');
          return true;
        }
        if (code === 'INVOICE_AMBIGUOUS' || code === 'INVOICE_CONFLICT') {
          this.showMessage('Não foi possível identificar o pedido desta nota fiscal com segurança. Entre em contato com a loja.');
          return true;
        }
        if (code === 'TRACKING_NOT_INDEXED') {
          this.showMessage(this.method === 'invoice_number' ? 'O rastreio desta nota ainda não está disponível. Tente novamente mais tarde ou entre em contato com a loja.' : 'Ainda não conseguimos localizar este código. Confira os dados ou entre em contato com a loja.', 'info');
          return true;
        }
        if (code === 'NOT_CONFIGURED' || code === 'ATON_NOT_CONFIGURED' || code === 'ATON_UNAVAILABLE') {
          this.showMessage('A consulta está temporariamente indisponível. Tente novamente mais tarde ou entre em contato com a loja.');
          return true;
        }
        return false;
      }
      safeTrackingUrl(raw) {
        if (typeof raw !== 'string' || raw.length > 2048) return null;
        try {
          const url = new URL(raw);
          if (url.protocol !== 'https:' || url.username || url.password || url.port || !this.allowedHosts.has(url.hostname.toLowerCase())) return null;
          return url;
        } catch { return null; }
      }
      trackingCode(raw) {
        let value = raw.trim();
        if (/^(?:https?:\/\/|www\.)/i.test(value) || value.includes('/')) {
          const url = this.safeTrackingUrl(/^https?:\/\//i.test(value) ? value : 'https://' + value);
          // Somente links Rastreie Já de um segmento podem ser normalizados aqui.
          if (!url || !['rastreieja.com.br', 'www.rastreieja.com.br'].includes(url.hostname.toLowerCase()) || url.search || url.hash) return '';
          try { value = decodeURIComponent(url.pathname.replace(/^\/+|\/+$/g, '')); } catch { return ''; }
        }
        return /^[a-zA-Z0-9_-]{1,128}$/.test(value) ? value : '';
      }
      invoiceNumber(raw) {
        const value = raw.trim();
        if (!/^[0-9]{1,9}$/.test(value)) return '';
        return value.replace(/^0+/, '');
      }
      endpoint() {
        const raw = this.dataset.endpoint || '';
        if (!/^\/(apps|a|tools|community)\/[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*$/.test(raw)) throw new Error('CONFIG');
        return new URL(raw, window.location.origin).href;
      }
      renderFound(data) {
        if (!Array.isArray(data.shipments) || !data.shipments.length || data.shipments.length > 20) throw new Error('RESPONSE');
        const shipments = data.shipments.map(item => ({ item, url: this.safeTrackingUrl(item?.trackingUrl) }));
        if (shipments.some(entry => !entry.url)) throw new Error('RESPONSE');
        const text = document.createElement('p');
        text.textContent = shipments.length > 1 ? 'Encontramos mais de um envio. Escolha qual deseja acompanhar.' : 'Rastreio encontrado. Abra pelo link abaixo.';
        const links = document.createElement('div');
        links.className = 'ot-shipments';
        shipments.forEach(({ url }, index) => {
          const link = document.createElement('a');
          link.className = 'ot-tracking-link';
          link.href = url.href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.referrerPolicy = 'no-referrer';
          link.addEventListener('click', event => {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.open(url.href, '_blank', 'noopener,noreferrer');
          });
          link.textContent = shipments.length > 1 ? 'Abrir envio ' + (index + 1) : 'Abrir rastreio';
          links.append(link);
        });
        this.message.hidden = true;
        this.result.replaceChildren(text, links);
        this.result.hidden = false;
        if (shipments.length === 1 && this.trackingTab && this.trackingTab !== window && !this.trackingTab.closed) {
          try {
            this.trackingTab.location.replace(shipments[0].url.href);
            this.trackingTab = null;
            text.textContent = 'Rastreio aberto em outra guia.';
          } catch { this.closeTrackingTab(); }
        }
      }
      async lookup() {
        if (this.isBusy) return;
        this.clear();
        const type = this.method;
        if (type === 'invoice_number' && this.dataset.invoiceEnabled !== 'true') {
          this.showMessage('A consulta por nota fiscal ainda não está disponível. Utilize o código de rastreio.'); return;
        }
        if (!['tracking_code', 'invoice_number'].includes(type)) return;
        const raw = this.input.value.trim();
        const value = type === 'invoice_number' ? this.invoiceNumber(raw) : this.trackingCode(raw);
        if (!value) {
          this.showMessage(type === 'invoice_number' ? 'Digite um número de nota fiscal válido, com até 9 dígitos.' : 'Digite um código válido ou um link Rastreie Já completo.', 'error', this.input);
          return;
        }
        const body = { type, value };
        let endpoint;
        try { endpoint = this.endpoint(); } catch { this.showMessage('A consulta ainda não está disponível. Entre em contato com a loja.'); return; }
        const version = ++this.version;
        const controller = new AbortController();
        this.request = controller;
        this.busy(true);
        this.showMessage('Buscando seu rastreio…', 'loading');
        this.openTrackingTab();
        let timedOut = false;
        const timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 20000);
        try {
          const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', cache: 'no-store', redirect: 'error', body: JSON.stringify(body), signal: controller.signal });
          if (version !== this.version) return;
          if (response.status === 429) { this.showMessage('Você fez muitas consultas. Aguarde um minuto e tente novamente.'); return; }
          if (response.status === 401 || response.status === 403 || response.status === 404) { this.showMessage('A consulta não está disponível no momento. Entre em contato com a loja.'); return; }
          if (response.status === 503) {
            let code = '';
            try {
              if ((response.headers.get('content-type') || '').includes('application/json')) {
                const unavailable = await response.json();
                code = unavailable?.error?.code || '';
              }
            } catch { /* Mensagem genérica se o servidor não retornar JSON válido. */ }
            if (version !== this.version) return;
            if (!this.showKnownError(code)) {
              this.showMessage('A consulta está temporariamente indisponível. Tente novamente mais tarde ou entre em contato com a loja.');
            }
            return;
          }
          if (!response.ok) { this.showMessage('Não foi possível consultar agora. Tente novamente em alguns instantes.'); return; }
          if (!(response.headers.get('content-type') || '').includes('application/json')) throw new Error('RESPONSE');
          const data = await response.json();
          if (version !== this.version) return;
          if (data?.ok === false && this.showKnownError(data.error?.code)) return;
          if (!data || data.ok !== true) throw new Error('RESPONSE');
          if (data.status === 'found') this.renderFound(data);
          else if (data.status === 'pending') this.showMessage('O rastreio ainda não está disponível. Tente novamente mais tarde.', 'info');
          else if (data.status === 'not_found') this.showMessage('Não encontramos um rastreio com os dados informados. Confira e tente novamente.');
          else if (data.status === 'ambiguous') this.showMessage('Não foi possível identificar um único pedido. Entre em contato com a loja.');
          else throw new Error('RESPONSE');
        } catch (error) {
          if (version !== this.version) return;
          if (error.name === 'AbortError' && !timedOut) return;
          this.showMessage(timedOut ? 'A consulta demorou mais que o esperado. Tente novamente.' : 'Não foi possível concluir a consulta. Tente novamente ou entre em contato com a loja.');
        } finally {
          clearTimeout(timeout);
          if (version === this.version) { this.closeTrackingTab(); this.request = null; this.busy(false); }
        }
      }
    }
    customElements.define('order-tracking-uplift', SisfreteTrackingNewTab);
  })();

  } catch(e) { console.error(e); }
})();
})();
